module.exports = __webpack_public_path__ + "static/media/sologoamarelo.98bcdfc3.png";